import React, { useEffect, useState } from 'react';
import {
  Checkbox,
  Col,
  Grid,
  IconButton,
  Input,
  Loader,
  Panel,
  Radio,
  RadioGroup,
  Row,
  SelectPicker,
  Stack
} from 'rsuite';
import '../HomePages/home.css';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import useLabel from '../hook/Label';
import ExpandOutlineIcon from '@rsuite/icons/ExpandOutline';
import MenuIcon from '@rsuite/icons/Menu';
import CollaspedOutlineIcon from '@rsuite/icons/CollaspedOutline';
import ActivityDrawer from './ActivityDrawer';
export default function ActivityPage() {
  const [allQyeryData2, setAllQyeryData2] = useState([]);
  const [allOpenedProductsIds, setAllOpenedProductsIds] = useState([]);
  // console.log('allOpenedProductsIds.....', allOpenedProductsIds)
  const [allSelectedPropductsIds, setAllSelectedPropductsIds] = useState([]);
  // console.log('allSelectedPropductsIds.....', allSelectedPropductsIds)
  const [activityData, setActivityData] = useState({ opened: [], selected: [] });
  // console.log('activityData-----' , activityData);
  
  const [allQyeryData, setAllQyeryData] = useState([]);
  const [filterKeys, setfilterKeys] = useState('all');
  const [isLoading, setIsLoading] = useState(false);
  const [isExpened, setIsExpened] = useState(true);
  const [open, setOpen] = useState();
  const { attributesName } = useLabel();
  const selectData = ['Quotation', 'Show Pricing', 'Need Sample', 'Order Confirm'].map(item => ({
    label: item,
    value: item
  }));

  useEffect(() => {
    const fetchData = async () => {
      const email = sessionStorage.getItem('loginemail');
      const mobile = sessionStorage.getItem('loginmobile');
      const userName = sessionStorage.getItem('loginusername');
      if (email && mobile) {
        const response = await fetch(
          `${globalIP}/api/clientactivities?populate=*&filters[loginemail][$eq]=${email}&filters[loginmobile][$eq]=${mobile}&filters[loginusername][$null]=true`
        );
        const allSelectedItems = await response.json();
        setAllQyeryData(allSelectedItems.data.flatMap(item => item.attributes.sentquery));
        setAllOpenedProductsIds(
          allSelectedItems.data.flatMap(item => item.attributes.openedproduct)
        );
        setAllSelectedPropductsIds(
          allSelectedItems.data.flatMap(item => item.attributes.shortlistproduct)
        );
      } else if (email && userName) {
        const response = await fetch(
          `${globalIP}/api/clientactivities?populate=*&filters[loginemail][$eq]=${email}&filters[loginusername][$eq]=${userName}&filters[loginmobile][$null]=true`
        );
        const allSelectedItems = await response.json();
        setAllQyeryData(allSelectedItems.data.flatMap(item => item.attributes.sentquery));

        setAllOpenedProductsIds(
          allSelectedItems.data.flatMap(item => item.attributes.openedproduct)
        );
        setAllSelectedPropductsIds(
          allSelectedItems.data.flatMap(item => item.attributes.shortlistproduct)
        );
      } else if (userName) {
        const response = await fetch(
          `${globalIP}/api/clientactivities?populate=*&filters[loginemail][$null]=true&filters[loginmobile][$null]=true&filters[loginusername][$eq]=${userName}`
        );
        const allSelectedItems = await response.json();
        // console.log('allSelectedItems----->', allSelectedItems);

        setAllQyeryData(allSelectedItems.data.flatMap(item => item.attributes.sentquery));
        setAllOpenedProductsIds(
          allSelectedItems.data.flatMap(item => item.attributes.openedproduct)
        );
        setAllSelectedPropductsIds(
          allSelectedItems.data.flatMap(item => item.attributes.shortlistproduct)
        );
      }
    };

    fetchData();
  }, []);
  const productCountsArray = Object.values(
    allOpenedProductsIds.reduce((acc, item) => {
      const productId = item.productid;
      acc[productId] = { ...acc[productId], count: (acc[productId]?.count || 0) + 1, productId };
      return acc;
    }, {})
  );

  const productCountsArray1 = Object.values(
    allSelectedPropductsIds.reduce((acc, item) => {
      const productId = item.productid;
      acc[productId] = { ...acc[productId], count: (acc[productId]?.count || 0) + 1, productId };
      return acc;
    }, {})
  );

  useEffect(() => {
    const fetchData = async (productCountsArray, activityType) => {
      try {
        const requests = productCountsArray.map(({ productId }) =>
          axios.get(`${globalIP}/api/products/${productId}?populate=*`)
        );
        const responses = await Promise.all(requests);
        const data = responses.map((response, index) => {
          // console.log('data.......', data);
          const { id } = response.data.data;
          // console.log('id.........' , id)
          
          const countObject = productCountsArray.find(item => item.productId == id);
          return {
            ...response.data.data,
            count: countObject ? countObject.count : 0
          };
        });
        setActivityData(prev => ({ ...prev, [activityType]: data }));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    if (productCountsArray.length) {
      fetchData(productCountsArray, 'opened');
    }
    if (productCountsArray1.length) {
      fetchData(productCountsArray1, 'selected');
    }
  }, [allOpenedProductsIds, allSelectedPropductsIds]);
  useEffect(() => {
    const fetchData = async () => {
      if (allQyeryData) {
        setIsLoading(true);
        const sentQueryProductIds = allQyeryData.map(item => item.productid) || [];
        const requests = sentQueryProductIds.map(productId =>
          axios.get(`${globalIP}/api/products/${productId}?populate=*`)
        );
        const responses = await Promise.all(requests);
        const data = responses.map((response, index) => {
          const { id } = response.data.data;
          const countObject = allQyeryData.find(item => item.productid == id);
          return {
            ...response.data.data,
            query: countObject?.query,
            price: countObject?.price,
            remark: countObject?.remark,
            reply: countObject?.reply
          };
        });
        setAllQyeryData2(data);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [allQyeryData]);
  const handlekeyChecked = data => {
    setfilterKeys(data);
    setOpen(false);
  };
  const filterData = allQyeryData2.filter(item => {
    if (filterKeys != 'opened') {
      if (filterKeys == 'all') {
        return true;
      } else if (filterKeys == 'response') {
        return item.reply != null && item.reply != '' ? true : false;
      } else if (filterKeys == 'noreply') {
        return item.reply == '' || item.reply == null ? true : false;
      }
    }
  });
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '80vh'
        }}
        color="cyan"
      >
        <Loader size="lg" />
      </div>
    );
  }
  return (
    <>
      <Grid fluid>
        <Row>
          <Col lg={24} xs={24}>
            <div style={{ padding: '10px 20px' }} className="product-hide-mobile">
              <IconButton
                icon={isExpened ? <CollaspedOutlineIcon /> : <ExpandOutlineIcon />}
                size="sm"
                onClick={() => setIsExpened(prev => !prev)}
                style={{ background: '#005c80', color: 'white' }}
              />
            </div>
            <div className="product-show-mobile">
              <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
                <IconButton icon={<MenuIcon />} size="sm" id="bb" onClick={() => setOpen(true)} />
              </div>
            </div>
          </Col>
          <Col
            lg={isExpened ? 4 : 0}
            style={{
              position: 'sticky',
              top: '52px',
              borderTop: '1px solid lightGrey',
              display: isExpened ? 'block' : 'none'
            }}
            className="product-hide-mobile"
          >
            <Stack direction="column" spacing={5} style={{ padding: '20px 0' }}>
              <RadioGroup
                name="radio-group"
                value={filterKeys}
                onChange={value => handlekeyChecked(value)}
              >
                <Radio name="querys" value="all">
                  <span className={`roboto-regular myquerys ${filterKeys == 'all' && 'active'}`}>
                    All Querys
                  </span>
                </Radio>
                <Radio name="querys" value="response">
                  <span
                    className={`roboto-regular myquerys ${filterKeys == 'response' && 'active'}`}
                  >
                    Response
                  </span>
                </Radio>
                <Radio name="querys" value="noreply">
                  <span
                    className={`roboto-regular myquerys ${filterKeys == 'noreply' && 'active'}`}
                  >
                    No Response
                  </span>
                </Radio>
                <Radio name="querys" value="opened">
                  <span className={`roboto-regular myquerys ${filterKeys == 'opened' && 'active'}`}>
                    Opened
                  </span>
                </Radio>
                <Radio name="querys" value="selected">
                  <span
                    className={`roboto-regular myquerys ${filterKeys == 'selected' && 'active'}`}
                  >
                    Selected
                  </span>
                </Radio>
              </RadioGroup>
            </Stack>
          </Col>
          <Col
            lg={isExpened ? 20 : 24}
            xs={24}
            style={{ borderLeft: '1px solid lightGrey', borderTop: '1px solid lightGrey' }}
          >
            {!['opened', 'selected'].includes(filterKeys) && (
              <div style={{ padding: '20px 10px 80px 20px' }}>
                <div className="activity-heading">
                  {['all'].includes(filterKeys)
                    ? 'All Querys'
                    : ['response'].includes(filterKeys)
                    ? 'Response'
                    : 'No Response'}
                </div>
                <Row gutter={16}>
                  {filterData.map(item => {
                    const { id, attributes, query, price, remark, reply } = item;
                    return (
                      <Col
                        lg={isExpened ? 12 : 8}
                        xs={24}
                        key={item.id}
                        style={{ marginBottom: '15px' }}
                      >
                        <Panel bordered>
                          <Row>
                            <Col xs={10}>
                              <div
                                style={{
                                  width: '150px',
                                  height: '150px',
                                  margin: 'auto',
                                  borderRadius: '5px',
                                  overflow: 'hidden'
                                }}
                                className="activity-image"
                              >
                                <img
                                  src={`${globalIP}${attributes.CoverImage.data.attributes.url}`}
                                  alt=""
                                  style={{ width: '100%', height: '100%' }}
                                />
                              </div>
                            </Col>
                            <Col xs={14}>
                              <div style={{ padding: '10px 20px 0 5px' }}>
                                <h6 style={{ fontSize: '12px' }}>{attributes.ProductName}</h6>
                                <span style={{ fontSize: '14px' }} className="roboto-regular">
                                  {attributesName?.AliasCode || 'Alias Code'} :{' '}
                                  {attributes.ProductId}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  padding: '10px 0px 10px 5px',
                                  gap: '10px'
                                }}
                              >
                                <SelectPicker
                                  data={selectData || []}
                                  id="query"
                                  size="sm"
                                  name="query"
                                  style={{ width: '100%' }}
                                  defaultValue={query}
                                  block
                                  placeholder="Select Query"
                                />
                                <Input
                                  style={{ width: '100%' }}
                                  placeholder="Price"
                                  size="sm"
                                  defaultValue={price}
                                />
                              </div>
                              <div style={{ padding: '0px 0px 10px 5px' }}>
                                <Input
                                  as="textarea"
                                  rows={2}
                                  placeholder="Remark"
                                  defaultValue={remark}
                                />
                              </div>
                            </Col>
                            <Col xs={24}>
                              <div>
                                <Input
                                  as="textarea"
                                  rows={3}
                                  placeholder="Reply"
                                  readOnly
                                  defaultValue={reply}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Panel>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            )}
            {['opened', 'selected'].includes(filterKeys) && (
              <div style={{ padding: '20px 10px 80px 20px' }}>
                <div className="activity-heading">
                  {['opened'].includes(filterKeys) ? 'Opened Products' : 'Selection Products'}
                </div>
                <Row>
                  {activityData[filterKeys].map(item => {
                    return (
                      <Col lg={isExpened ? 8 : 6} xs={24} key={item.id}>
                        <div className="product-box">
                          <div className={'product-img'}>
                            <img
                              src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                              alt=""
                              className="imgp111111"
                              loading="lazy"
                            />
                          </div>
                          <div className="ribbon1">
                            <span className="ribbon__content1">Exclusive</span>
                          </div>
                          <div className="product-details">
                            <h6
                              style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}
                            >
                              Product <span>{item?.attributes?.ProductName}</span>
                            </h6>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                              }}
                            >
                              <p
                                style={{
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                Alias Code {item?.attributes?.ProductId}
                              </p>
                              <p>Count : {item?.count}</p>
                            </div>
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            )}
          </Col>
        </Row>
      </Grid>
      <Stack
        className="copyright"
        justifyContent="flex-end"
        spacing={5}
        style={{
          position: 'fixed',
          bottom: '0',
          width: '-webkit-fill-available',
          textAlign: 'center',
          backgroundColor: 'white',
          padding: '10px 20px',
          borderTop: '1px solid lightGrey',
          zIndex: 100000000000000000000,
          background: 'white'
        }}
      >
        <p>© All Right Reserved. Product by </p>
        <p>
          <a href="https://erpdaddy.com/" target="_blank" color="#005c80">
            ERPDaddy Software Solution.
          </a>
        </p>
      </Stack>
      <ActivityDrawer
        filterKeys={filterKeys}
        handlekeyChecked={handlekeyChecked}
        close={() => setOpen(false)}
        open={open}
      />
    </>
  );
}
